export default "__VITE_ASSET__fjBth4oJ__"